import { ReactComponent as CustomizeIcon } from './customize.svg';

export default CustomizeIcon;
